
<template>
  <div class="table">
    <slot name="title"></slot>
    <el-table :data="tableData" border :max-height="tableHeight" @row-click="changePie">
      <el-table-column type="index" width="50" align="center" label="序号"></el-table-column>
      <el-table-column prop="companyName" align="center" label="企业名称">
        <template slot-scope="scope" align="center">
          <span
            @click="changePie(scope.row.petrochemicalStopRadio,scope.row.petroleumStopCount,scope.row.otherStopCount,scope.row.companyName)"
          >{{scope.row.companyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="provname" align="center" label="所属省份"></el-table-column>
      <el-table-column prop="cityname" align="center" label="所属地市"></el-table-column>
      <el-table-column prop="vehicleCount" align="center" label="车辆数">
        <template slot-scope="scope">
         {{ format(scope.row.vehicleCount)}}
        </template>
      </el-table-column>
      <el-table-column prop="mileage" align="center" label="运营公里">
        <template slot-scope="scope">
         {{ format(scope.row.mileage)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" prop="name">
        <template slot-scope="scope">
          <span style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row.companyName)">车辆详情</span>
        </template>
      </el-table-column>
    </el-table>
    <slot name="pagin"></slot>
  </div>
</template>
<script>
/**
 * @file:  View 组件 table
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: UI组件
 */
export default {
  props: {
    tableData: {
      default: () => {
        return []
      },
      type: Array
    },
    toDetail: {
      default: () => {},
      type: Function
    },
    changePie: {
      default: () => {},
      type: Function
    }
  },
  methods:{
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  }
}
</script>
